import financialServicesBins from '@engine/features/financial_services_bins';
import { toggleRequiredAttributes } from '@engine/lib/utility/toggle_required_attributes';
var BIN_LENGTH = 6;

function isBinInFinancialServicesBins(startingCardNumber) {
  var bin = startingCardNumber.replace(/\s/g, '').substring(0, BIN_LENGTH);

  if (bin.length !== BIN_LENGTH) {
    return false;
  }

  return financialServicesBins.includes(Number(bin));
}

export function handleBirthDateFields() {
  if (typeof $('input[name*=card_number]').val() === 'undefined') {
    return;
  }

  var $cardNumber = $('input[name*=card_number]');
  var startingCardNumber = $cardNumber.val();
  var $birthDate = $('#birth_date_params.with-birth-date');

  if (isBinInFinancialServicesBins(startingCardNumber)) {
    $birthDate.removeClass('hidden');
    toggleRequiredAttributes($birthDate.find('select'), true);
  } else {
    $birthDate.addClass('hidden');
    toggleRequiredAttributes($birthDate.find('select'), false);
  }
}